import React from 'react';
import { css } from '@emotion/core';
import Button from '@atlaskit/button';
import EditorWarningIcon from '@atlaskit/icon/glyph/editor/warning';
import { token } from '@atlaskit/tokens';

import { colors, SPACE_COMPACT } from '@/styles';
import { GraphState } from '@/components/composed/slo-card/graph/types';
import AdvancedDropdown from '@/components/composed/slo-group/advanced-dropdown';

const tabStyles = (align: string) => css`
  display: flex;
  justify-content: ${align === 'left' ? 'flex-start' : 'flex-end'};
  gap: ${SPACE_COMPACT}px;
  margin-bottom: ${SPACE_COMPACT}px;
`;

export enum GraphEventSource {
  Active = 'Active',
  Historical = 'Historical',
}

function GraphTabs({
  graphEventSource,
  setToggleState,
  graphState,
  align = 'right',
  hasEventsFromHistoricalIndicators = false,
  hasWarnings = false,
  onToggleHistoricalIndicators,
}: {
  setToggleState: Function;
  graphState: GraphState;
  align?: 'right' | 'left';
  hasEventsFromHistoricalIndicators?: boolean;
  hasWarnings?: boolean;
  onToggleHistoricalIndicators: (value: string[]) => void;
  graphEventSource: GraphEventSource;
}) {
  const isSelectedGraphState = (state: GraphState) => graphState === state;
  return (
    <div css={tabStyles(align)}>
      {hasWarnings && (
        <>
          <Button
            isSelected={isSelectedGraphState(GraphState.ShowErrorBudgetGraph)}
            appearance="default"
            onClick={() => setToggleState(GraphState.ShowErrorBudgetGraph)}
          >
            Error Budget
          </Button>
          <Button
            testId="slo-card-warnings-button"
            isSelected={isSelectedGraphState(GraphState.ShowWarnings)}
            appearance="default"
            onClick={() => setToggleState(GraphState.ShowWarnings)}
            iconBefore={
              <EditorWarningIcon label="" primaryColor={token('color.text.warning', colors.Y500)} />
            }
          >
            Warnings
          </Button>
        </>
      )}
      {hasEventsFromHistoricalIndicators && (
        <AdvancedDropdown
          label="Alert Source"
          onChange={onToggleHistoricalIndicators}
          value={graphEventSource}
          options={[
            { label: 'Active SLO Config', value: GraphEventSource.Active },
            { label: 'Historical SLO Configs', value: GraphEventSource.Historical },
          ]}
          closeMenuOnSelect={false}
          hideResetButton
        />
      )}
    </div>
  );
}

export default GraphTabs;
